import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const WentWrong = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="105"
      height="105"
      viewBox="0 0 105 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame">
        <g id="Group">
          <path
            id="Vector"
            d="M100.735 45.5609V97.8288C100.735 100.289 98.7411 102.283 96.2813 102.283H10.4305C7.97064 102.283 5.97656 100.289 5.97656 97.8288V43.6885H98.863C99.3595 43.6885 99.8357 43.8858 100.187 44.237C100.538 44.5881 100.735 45.0643 100.735 45.5609Z"
            fill="#EEEEEE"
          />
          <path
            id="Vector_2"
            d="M98.7597 5.35195L101.57 16.7446C101.969 18.3621 100.981 19.9966 99.3634 20.3956L5.74409 43.4866L3.61148 34.8408C2.43945 30.0889 5.3415 25.2866 10.0934 24.1146L95.1087 3.1456C96.7262 2.74666 98.3608 3.73446 98.7597 5.35195ZM91.1356 56.7095V89.2615C91.1356 91.9758 88.9352 94.1763 86.2208 94.1763H20.5005C17.7862 94.1763 15.5857 91.9758 15.5857 89.2615V56.7095C15.5857 53.9951 17.7862 51.7946 20.5005 51.7946H86.2208C88.9352 51.7946 91.1356 53.9951 91.1356 56.7095Z"
            fill="white"
          />
          <path
            id="Vector_3"
            d="M87.447 5.03516L74.4519 26.5396L53.694 31.6596L66.6972 10.1531L87.447 5.03516ZM47.8624 14.7988L34.8673 36.3032L14.1094 41.4232L27.1126 19.9167L47.8624 14.7988Z"
            fill="#EE2D58"
          />
          <g id="Group_2">
            <path
              id="Vector_4"
              d="M101.899 97.8249V45.5611C101.899 43.8853 100.539 42.5223 98.8677 42.5223H24.3631C23.7208 42.5223 23.2002 43.0427 23.2002 43.6852C23.2002 44.3277 23.7206 44.8481 24.3631 44.8481H98.8677C99.2565 44.8481 99.5729 45.168 99.5729 45.5613V97.8251C99.5729 99.6417 98.0987 101.12 96.2864 101.12H10.433C8.61641 101.12 7.13827 99.6417 7.13827 97.8251V48.2202C7.13827 47.5779 6.61787 47.0573 5.97538 47.0573C5.3329 47.0573 4.81249 47.5777 4.81249 48.2202V97.8249C4.81249 100.924 7.33388 103.445 10.4328 103.445H96.286C99.381 103.445 101.899 100.924 101.899 97.8249ZM102.697 16.4659L99.8868 5.07339C99.3341 2.83556 97.0784 1.46386 94.8281 2.01636L9.81282 22.9854C4.44626 24.3093 1.15685 29.7525 2.48021 35.1194L4.61282 43.765C4.67517 44.0173 4.82013 44.2414 5.02462 44.4017C5.2291 44.562 5.48135 44.6493 5.74118 44.6497C5.96096 44.6497 1.68294 45.6854 99.6398 21.5247C101.882 20.971 103.25 18.7092 102.697 16.4659ZM56.1422 29.8577L67.443 11.1665L84.9997 6.83611L73.7058 25.5254C65.8034 27.4748 60.8494 28.6968 56.1422 29.8577ZM37.3145 34.5017L48.6085 15.8122L64.2493 11.9544L52.9484 30.6456L37.3145 34.5017ZM16.5574 39.6213L27.8586 20.9299L45.4154 16.5997L34.1214 35.289L16.5574 39.6213ZM4.73855 34.5623C3.72191 30.4407 6.24838 26.2603 10.3702 25.2435L24.6647 21.7179L13.3636 40.409L6.59268 42.0791L4.73855 34.5623ZM99.0828 19.2665L76.8989 24.7381L88.1929 6.04859L95.3853 4.2745C96.3766 4.02851 97.3826 4.63362 97.6284 5.63036L100.438 17.0228C100.497 17.2592 100.508 17.5047 100.472 17.7454C100.435 17.9862 100.352 18.2173 100.226 18.4257C100.1 18.6341 99.9341 18.8156 99.738 18.9599C99.5418 19.1042 99.3192 19.2084 99.0828 19.2665Z"
              fill="#4B4B55"
            />
            <path
              id="Vector_5"
              d="M86.2199 95.339C89.5712 95.339 92.2978 92.6127 92.2978 89.2615V56.7097C92.2978 53.3584 89.5714 50.6318 86.2199 50.6318H20.4998C17.1484 50.6318 14.4219 53.3584 14.4219 56.7097V89.2617C14.4219 92.6127 17.1484 95.3392 20.4998 95.3392H86.2199V95.339ZM16.7477 89.2617V56.7097C16.7477 54.6407 18.431 52.9576 20.4998 52.9576H86.2199C88.2889 52.9576 89.972 54.6409 89.972 56.7097V89.2617C89.972 91.3308 88.2887 93.0137 86.2199 93.0137H20.4998C18.4307 93.0135 16.7477 91.3306 16.7477 89.2617Z"
              fill="#4B4B55"
            />
          </g>
          <g id="Group_3">
            <path
              id="Vector_6"
              d="M50.9969 59.7903L50.9969 59.7903L37.5369 83.495L37.5368 83.495C36.5075 85.3079 37.8169 87.5573 39.9018 87.5573H66.8223C68.9072 87.5573 70.2166 85.3078 69.1871 83.4949L55.7267 59.7903L55.7267 59.7903C54.6843 57.9547 52.0393 57.9547 50.9969 59.7903Z"
              fill="#EE2D58"
              stroke="#4B4B55"
              strokeWidth="2"
            />
          </g>
          <g id="Group 964">
            <path
              id="Vector_7"
              d="M54.8479 68.7819L54.5068 76.7566C54.4804 77.3719 53.9739 77.8572 53.3581 77.8572C52.7422 77.8572 52.2357 77.3719 52.2094 76.7566L51.8683 68.7819C51.8403 68.1282 52.3627 67.583 53.0169 67.583H53.6992C54.3534 67.583 54.8759 68.1282 54.8479 68.7819Z"
              fill="white"
            />
            <path
              id="Vector_8"
              d="M53.3556 82.8206C54.2036 82.8206 54.8909 82.1332 54.8909 81.2853C54.8909 80.4374 54.2036 79.75 53.3556 79.75C52.5077 79.75 51.8203 80.4374 51.8203 81.2853C51.8203 82.1332 52.5077 82.8206 53.3556 82.8206Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

WentWrong.displayName = 'WentWrong';
